import { render, staticRenderFns } from "./Rule63ResponseInstructions.vue?vue&type=template&id=1f386d80&scoped=true"
import script from "./Rule63ResponseInstructions.vue?vue&type=script&lang=ts"
export * from "./Rule63ResponseInstructions.vue?vue&type=script&lang=ts"
import style0 from "./Rule63ResponseInstructions.vue?vue&type=style&index=0&id=1f386d80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f386d80",
  null
  
)

export default component.exports